import type { SVGProps } from "react";
export interface CarTaxiIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function CarTaxiIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: CarTaxiIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M17.5 14.628a.62.62 0 0 0-.125.373l.013.126c.019.09.059.171.111.243zm1 .742a.6.6 0 0 0 .113-.243l.012-.127-.012-.126a.6.6 0 0 0-.113-.246zm-11.887-.495a.6.6 0 0 0-.113-.247v.742a.6.6 0 0 0 .113-.243L6.625 15zM5.5 14.627a.62.62 0 0 0-.125.373l.013.126c.019.09.059.171.112.243zM2.875 11c0-.423-.3-.775-.7-.857L2 10.125l-.116-.005A1.126 1.126 0 0 1 2 7.875l.32.017A3.125 3.125 0 0 1 5.124 11a1.125 1.125 0 0 1-2.25 0Zm16 0A3.125 3.125 0 0 1 22 7.875a1.125 1.125 0 0 1 0 2.25.875.875 0 0 0-.875.875 1.125 1.125 0 0 1-2.25 0m-11.25 4a1.625 1.625 0 0 1-3.242.166l-.008-.165.008-.167A1.626 1.626 0 0 1 6 13.373l.166.01c.82.082 1.459.775 1.459 1.617m12 0a1.625 1.625 0 0 1-3.242.166l-.008-.165.008-.167A1.626 1.626 0 0 1 18 13.373l.166.01c.82.082 1.459.775 1.459 1.617m-2.5-11a1.125 1.125 0 0 1-2.25 0v-.875h-5.75V4a1.125 1.125 0 0 1-2.25 0V3C6.875 1.827 7.827.875 9 .875h6c1.174 0 2.125.952 2.125 2.125z"
      />
      <path
        fill={color}
        d="M20.875 15A2.874 2.874 0 0 0 18 12.125H6a2.875 2.875 0 0 0-2.875 2.873v2.876h17.75v-2.876ZM8.262 5.124c-.836 0-1.571.555-1.802 1.36L5.483 9.9q.255-.025.517-.025h12q.261 0 .516.025l-.975-3.416a1.875 1.875 0 0 0-1.804-1.359H8.262ZM23.125 21a1.125 1.125 0 0 1-2.25 0v-.875H3.125V21a1.125 1.125 0 0 1-2.25 0v-6c0-1.655.785-3.127 2.002-4.064q.007-.122.041-.245l1.379-4.825.107-.325a4.13 4.13 0 0 1 3.858-2.666h7.475a4.125 4.125 0 0 1 3.967 2.991l1.377 4.825.026.112q.01.067.014.133a5.12 5.12 0 0 1 2.004 4.063v6Z"
      />
    </svg>
  );
}
